// localStorage key for a referral/promo code captured from the URL, so it survives
// internal navigation (which strips ?promoCode) until the user reaches registration.
export const REFERRAL_CODE_STORAGE_KEY = 'wp.referralCode';

// localStorage key for an invite code captured from the email link (?inviteCode), so it
// survives the register/login redirects and can be accepted once the user is authenticated.
export const INVITE_CODE_STORAGE_KEY = 'wp.inviteCode';

// The email the pending invite was sent to (?email on the same link), kept next to the code so
// every accept path can tell an invite meant for someone else before calling the backend.
export const INVITE_EMAIL_STORAGE_KEY = 'wp.inviteEmail';

// localStorage key for the first-touch marketing attribution bundle captured from the landing
// URL, so it survives internal navigation (which strips the query string) and the
// register -> confirm flow, and can ride the /auth/confirm request.
export const ATTRIBUTION_STORAGE_KEY = 'wp.attribution';

// One-shot first touch for the first bp_created event after registration confirmation.
export const SIGNUP_ATTRIBUTION_STORAGE_KEY = 'wp.signupAttribution';
